import React from "react";
import { Link } from "react-router-dom";

// Shared marketing header + footer. Used by Landing, Pricing, and Features
// so the public web has a single consistent navigation surface.

export function MarketingNav({ active }) {
  const links = [
    { to: "/", label: "Home", key: "home" },
    { to: "/features", label: "Features", key: "features" },
    { to: "/pricing", label: "Pricing", key: "pricing" },
  ];
  return (
    <header
      className="sticky top-0 z-30 bg-background/85 backdrop-blur-md border-b border-border/40 pt-safe"
      data-testid="marketing-nav"
    >
      <div className="max-w-[1080px] mx-auto px-5 sm:px-8 h-[60px] flex items-center justify-between">
        <Link to="/" data-testid="marketing-logo" className="flex items-center gap-2 tap">
          <img src="/kinly_app_icon_OFFICIAL.png" alt="Kinly" className="w-8 h-8 rounded-lg" />
          <span className="font-display text-[18px] font-medium tracking-tight">Kinly</span>
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2 text-sm">
          {links.map(l => (
            <Link
              key={l.key}
              to={l.to}
              data-testid={`marketing-nav-${l.key}`}
              className={[
                "px-2 sm:px-3 py-1 tap rounded-full text-[13px] sm:text-[14px] transition-colors",
                active === l.key
                  ? "text-foreground font-medium"
                  : "text-muted-foreground hover:text-foreground",
              ].join(" ")}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/signin"
            replace
            data-testid="marketing-signin"
            className="ml-2 h-9 px-4 rounded-full bg-foreground text-background text-[13px] font-medium tap inline-flex items-center"
          >
            Sign in
          </Link>
        </nav>
      </div>
    </header>
  );
}

export function MarketingFooter() {
  return (
    <footer
      className="px-5 sm:px-8 py-10 border-t border-border/40"
      data-testid="marketing-footer"
    >
      <div className="max-w-[1080px] mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <img src="/kinly_app_icon_OFFICIAL.png" alt="" className="w-6 h-6 rounded" />
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Geminii Properties · trading as Geminii AI
          </p>
        </div>
        <nav className="flex flex-wrap gap-4 text-xs text-muted-foreground">
          <Link to="/pricing" className="hover:text-foreground">Pricing</Link>
          <Link to="/features" className="hover:text-foreground">Features</Link>
          <Link to="/privacy" className="hover:text-foreground">Privacy</Link>
          <Link to="/terms" className="hover:text-foreground">Terms</Link>
          <a href="mailto:support@kinly.geminii-ai.com" className="hover:text-foreground">Support</a>
        </nav>
      </div>
      <p className="max-w-[1080px] mx-auto mt-3 text-xs text-muted-foreground">
        Made in Mpumalanga, South Africa · for families everywhere.
      </p>
    </footer>
  );
}
